import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ContactForm from '../components/ContactForm';

const ContactPage = () => {
    const contactInfo = [
        {
            icon: "📍",
            title: "Visit Our Headquarters",
            details: [
                "416/2, Rajbir Gautam House",
                "Ghitorni, M.G. Road",
                "South West Delhi",
                "PIN: 110030",
                "India"
            ]
        },
        {
            icon: "📞",
            title: "Contact Information",
            details: [
                "Phone: +91 8130804488",
                "Email: cmd@heimdall.org.in",
                "Website: www.golf4i.com",
                "Hours: Mon-Sun, 6AM-10PM"
            ]
        },
        {
            icon: "🏌️",
            title: "Quick Services",
            details: [
                "General Inquiries: info@golf4i.com",
                "Academy: academy@golf4i.com",
                "Corporate Events: events@golf4i.com",
                "Equipment: shop@golf4i.com"
            ]
        }
    ];

    const branches = [
        {
            city: "Delhi",
            address: "Golf4International Headquarters, Ghitorni",
            phone: "+91 8130804488",
            email: "delhi@golf4i.com"
        },
        {
            city: "Mumbai",
            address: "Bandra Kurla Complex, Mumbai",
            phone: "+91 22 6789 1234",
            email: "mumbai@golf4i.com"
        },
        {
            city: "Bengaluru",
            address: "Whitefield, Bengaluru",
            phone: "+91 80 4567 8901",
            email: "bengaluru@golf4i.com"
        }
    ];

    return (
        <>
            {/* Hero Section */}
            <section style={{
                height: '50vh',
                background: 'linear-gradient(rgba(31, 61, 43, 0.9), rgba(31, 61, 43, 0.95)), url(https://images.unsplash.com/photo-1535131749006-b7f58c99034b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80) center/cover no-repeat',
                display: 'flex',
                alignItems: 'center'
            }}>
                <Container>
                    <Row>
                        <Col lg={8} className="text-white">
                            <h1 className="display-4 fw-bold mb-4" style={{ color: '#B59A5A' }}>Contact Us</h1>
                            <p className="lead" style={{ opacity: 0.9 }}>
                                Get in touch with our golf experts. We're here to help you elevate your game.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contact Information Section */}
            <section className="section-padding">
                <Container>
                    <Row className="mb-5">
                        <Col lg={8} className="mx-auto text-center">
                            <h2 className="mb-4">Get in Touch</h2>
                            <p style={{ color: '#666', fontSize: '1.1rem' }}>
                                Have questions about our services, membership, or facilities? Our team is ready to assist you.
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-4 mb-5">
                        {contactInfo.map((info, index) => (
                            <Col md={4} key={index}>
                                <div className="p-4 h-100 text-center border rounded hover-lift" style={{
                                    transition: 'all 0.3s ease',
                                    borderColor: 'rgba(31, 61, 43, 0.1)'
                                }}>
                                    <div style={{
                                        width: '70px',
                                        height: '70px',
                                        backgroundColor: 'var(--soft-sage)',
                                        borderRadius: '50%',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '2rem',
                                        marginBottom: '1.5rem'
                                    }}>
                                        {info.icon}
                                    </div>
                                    <h3 className="h5 mb-3" style={{ color: 'var(--primary-green)' }}>
                                        {info.title}
                                    </h3>
                                    <ul className="list-unstyled" style={{ color: '#666' }}>
                                        {info.details.map((detail, idx) => (
                                            <li key={idx} className="mb-2">{detail}</li>
                                        ))}
                                    </ul>
                                </div>
                            </Col>
                        ))}
                    </Row>

                    <Row className="g-5">
                        <Col lg={6}>
                            <div className="mb-5">
                                <h3 className="h4 mb-4">Send Us a Message</h3>
                                <p style={{ color: '#666' }} className="mb-4">
                                    Fill out the form below and one of our golf professionals will get back to you within 24 hours.
                                    Whether you're interested in lessons, membership, or corporate events, we're here to help.
                                </p>

                                <div className="mb-4">
                                    <h4 className="h5 mb-3">Response Time</h4>
                                    <ul style={{ color: '#666' }}>
                                        <li className="mb-2">General Inquiries: Within 24 hours</li>
                                        <li className="mb-2">Membership Applications: Within 48 hours</li>
                                        <li className="mb-2">Event Bookings: Within 12 hours</li>
                                        <li>Urgent Matters: Call us directly</li>
                                    </ul>
                                </div>
                            </div>

                            <div>
                                <h4 className="h5 mb-3">Our Branches</h4>
                                <Row className="g-3">
                                    {branches.map((branch, index) => (
                                        <Col md={12} key={index}>
                                            <div className="p-3 border rounded">
                                                <h5 className="h6 mb-2" style={{ color: 'var(--muted-gold)' }}>{branch.city}</h5>
                                                <p className="small mb-1" style={{ color: '#666' }}>{branch.address}</p>
                                                <p className="small mb-1" style={{ color: '#666' }}>{branch.phone}</p>
                                                <p className="small mb-0" style={{ color: '#666' }}>{branch.email}</p>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        </Col>

                        <Col lg={6}>
                            <ContactForm />
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Map and Directions Section */}
            <section className="section-padding bg-soft-sage">
                <Container>
                    <Row className="mb-5">
                        <Col lg={8} className="mx-auto text-center">
                            <h2 className="mb-4">Find Us</h2>
                            <p style={{ color: '#666' }}>
                                Visit our flagship facility in Delhi or explore our other locations across India.
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-5 align-items-center">
                        <Col lg={6}>
                            <div className="rounded overflow-hidden" style={{
                                height: '400px',
                                background: 'linear-gradient(rgba(31, 61, 43, 0.1), rgba(31, 61, 43, 0.2)), url(https://images.unsplash.com/photo-1546483875-ad9014c88eba?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80) center/cover no-repeat',
                                position: 'relative'
                            }}>
                                <div className="position-absolute bottom-0 start-0 end-0 p-4 text-white" style={{
                                    background: 'linear-gradient(transparent, rgba(31, 61, 43, 0.9))'
                                }}>
                                    <h4 className="h5 mb-2">Golf4International Headquarters</h4>
                                    <p className="small mb-0" style={{ opacity: 0.9 }}>
                                        Flagship facility with complete golf ecosystem
                                    </p>
                                </div>
                            </div>
                        </Col>

                        <Col lg={6}>
                            <div className="p-4 bg-white rounded">
                                <h3 className="h4 mb-3">Directions & Parking</h3>

                                <div className="mb-4">
                                    <h5 className="h6 mb-2" style={{ color: 'var(--muted-gold)' }}>By Metro</h5>
                                    <p style={{ color: '#666' }} className="small mb-0">
                                        Nearest Metro Station: Ghitorni Metro Station (Yellow Line)
                                        <br />
                                        Walking distance: 10 minutes
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 className="h6 mb-2" style={{ color: 'var(--muted-gold)' }}>By Car</h5>
                                    <p style={{ color: '#666' }} className="small mb-0">
                                        From Delhi Airport: 30 minutes via NH48
                                        <br />
                                        From Connaught Place: 25 minutes via Sardar Patel Marg
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 className="h6 mb-2" style={{ color: 'var(--muted-gold)' }}>Parking</h5>
                                    <p style={{ color: '#666' }} className="small mb-0">
                                        • Ample parking available for 100+ cars
                                        <br />
                                        • Valet parking service
                                        <br />
                                        • Electric vehicle charging stations
                                        <br />
                                        • Secure bicycle parking
                                    </p>
                                </div>

                                <div>
                                    <h5 className="h6 mb-2" style={{ color: 'var(--muted-gold)' }}>Facility Hours</h5>
                                    <p style={{ color: '#666' }} className="small mb-0">
                                        Monday - Sunday: 6:00 AM - 10:00 PM
                                        <br />
                                        Last Entry: 9:00 PM
                                        <br />
                                        Special Events: Extended hours available
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* FAQ Section */}
            <section className="section-padding">
                <Container>
                    <Row className="mb-5">
                        <Col lg={8} className="mx-auto text-center">
                            <h2 className="mb-4">Frequently Asked Questions</h2>
                            <p style={{ color: '#666' }}>
                                Quick answers to common questions about contacting us.
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={10} className="mx-auto">
                            <div className="row g-4">
                                {[
                                    {
                                        question: "What's the best way to contact you for membership inquiries?",
                                        answer: "For membership inquiries, please use the contact form above or email membership@golf4i.com. You can also visit our facility for a personal tour and consultation."
                                    },
                                    {
                                        question: "Do I need to book appointments for golf lessons in advance?",
                                        answer: "Yes, we recommend booking golf lessons at least 48 hours in advance to ensure coach availability. You can book through our website, mobile app, or by calling our academy desk."
                                    },
                                    {
                                        question: "What are your corporate event booking procedures?",
                                        answer: "Corporate events require advance booking. Please contact our events team at events@golf4i.com with your requirements, preferred dates, and group size. We'll provide a customized proposal within 24 hours."
                                    },
                                    {
                                        question: "Can I visit your facility without an appointment?",
                                        answer: "Yes, our facility is open for walk-in visits during operating hours. However, for personalized tours or specific service consultations, we recommend scheduling an appointment."
                                    },
                                    {
                                        question: "How do I get updates about upcoming tournaments and events?",
                                        answer: "Subscribe to our newsletter through the form below to receive regular updates about tournaments, events, and special offers. You can also follow us on social media for real-time updates."
                                    },
                                    {
                                        question: "What payment methods do you accept?",
                                        answer: "We accept all major credit/debit cards, UPI payments, net banking, and cash. Corporate bookings can be made through bank transfers with proper documentation."
                                    }
                                ].map((faq, index) => (
                                    <Col md={6} key={index}>
                                        <div className="p-3 border rounded h-100" style={{ borderColor: 'rgba(31, 61, 43, 0.1)' }}>
                                            <h5 className="h6 mb-2" style={{ color: 'var(--primary-green)' }}>
                                                {faq.question}
                                            </h5>
                                            <p style={{ color: '#666' }} className="small mb-0">
                                                {faq.answer}
                                            </p>
                                        </div>
                                    </Col>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Newsletter Subscription */}
            <section className="section-padding bg-soft-sage">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center">
                            <div className="p-5 bg-white rounded">
                                <div style={{
                                    width: '80px',
                                    height: '80px',
                                    backgroundColor: 'var(--soft-sage)',
                                    borderRadius: '50%',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '1.5rem'
                                }}>
                                    <span style={{ fontSize: '2rem', color: 'var(--muted-gold)' }}>✉️</span>
                                </div>
                                <h3 className="h4 mb-3">Stay Connected</h3>
                                <p style={{ color: '#666' }} className="mb-4">
                                    Subscribe to our newsletter for golf tips, event updates, and exclusive offers.
                                </p>
                                <div className="input-group mx-auto" style={{ maxWidth: '500px' }}>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Enter your email address"
                                        style={{ padding: '12px' }}
                                    />
                                    <button className="btn-gold-filled" type="button">
                                        Subscribe
                                    </button>
                                </div>
                                <p className="small text-muted mt-3 mb-0">
                                    We respect your privacy. Unsubscribe at any time.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ContactPage;